/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Support(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                viewBox='0 0 30.01 26.31'
                xmlns='http://www.w3.org/2000/svg'
            >
                <title>support</title>
                <g
                    data-name='Layer 2'
                    id='Layer_2'
                >
                    <g
                        data-name='Layer 1'
                        fill={iconColor || '#000'}
                        id='Layer_1-2'
                    >
                        <path d='M29.5,1.94A3.4,3.4,0,0,0,28.07.51,5.51,5.51,0,0,0,25.16,0H8.77A5.34,5.34,0,0,0,5.94.51,3.48,3.48,0,0,0,4.5,1.94,4,4,0,0,0,4.12,3a4.52,4.52,0,0,0-2.18.5A3.48,3.48,0,0,0,.5,4.94,5.28,5.28,0,0,0,0,7.57v18a.77.77,0,0,0,.76.76h0a.78.78,0,0,0,.53-.25l4.22-4.71H21.16a5.63,5.63,0,0,0,2.91-.5,3.4,3.4,0,0,0,1.43-1.43,3.74,3.74,0,0,0,.38-1.08,4.73,4.73,0,0,0,2.19-.49,3.4,3.4,0,0,0,1.43-1.43A5,5,0,0,0,30,13.87v-9A5.51,5.51,0,0,0,29.5,1.94ZM25,16.5a4.57,4.57,0,0,1-.39,2.44,2.42,2.42,0,0,1-1,1,4.67,4.67,0,0,1-2.44.39H5.1L1,24.9V7.62H1a4.43,4.43,0,0,1,.38-2.2,2.51,2.51,0,0,1,1-1A4.7,4.7,0,0,1,4.85,4H21.16a4.7,4.7,0,0,1,2.44.38,2.42,2.42,0,0,1,1,1A4.57,4.57,0,0,1,25,7.85Zm4-2.63a4,4,0,0,1-.39,2.07,2.42,2.42,0,0,1-1,1,3.61,3.61,0,0,1-1.61.37c0-.25,0-.52,0-.83V7.85a5.51,5.51,0,0,0-.51-2.91,3.4,3.4,0,0,0-1.43-1.43A5.51,5.51,0,0,0,21.16,3h-16a3.28,3.28,0,0,1,.23-.59,2.51,2.51,0,0,1,1-1A4.62,4.62,0,0,1,8.77,1H25.16a4.7,4.7,0,0,1,2.44.38,2.42,2.42,0,0,1,1,1A4.57,4.57,0,0,1,29,4.85Z' />
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}